<template>
    <div class="certification">
        <Header title="实名认证" :show-back="true"/>
        <div class="container">
            <div class="form">
                <dl class="form-cell">
                    <dd class="form-cell-label">
                        <span class="idot">*</span>真实姓名
                    </dd>
                    <dd class="form-cell-input">
                        <input placeholder="请输入真实姓名" v-model="real_name"/>
                    </dd>
                </dl>
                <dl class="form-cell">
                    <dd class="form-cell-label">
                        <span class="idot">*</span>身份证号码
                    </dd>
                    <dd class="form-cell-input">
                        <input placeholder="请输入身份证号码" v-model="id_card"/>
                    </dd>
                </dl>
            </div>
            <button class="form-item-btn" @click="submit">确定</button>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import {mapMutations} from "vuex"

    export default {
        components: {
            Header
        },
        data() {
            return {
                real_name: "",
                id_card: ""
            };
        },
        methods: {
            submit() {
                let parmes = {
                    real_name: this.real_name,
                    id_card: this.id_card,
                };
                this.ajax.post("appapi/user/setRealName", parmes).then(res => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.setUserInfo({real_name: this.real_name});
                        this.$router.go(-1);
                    }
                });
            },
            ...mapMutations({
                setUserInfo: "setUserInfo"
            })
        }
    }
</script>

<style lang="scss">
    .certification {
        .container {
            padding: 12px 32px;

            .form {
                background: rgba(255, 255, 255, 1);
                box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
                border-radius: 20px;

                &-cell {
                    @include flex($main: space-between);
                    padding: 30px 30px 30px 14px;
                    font-size: 26px;
                    position: relative;

                    &-label {
                        font-size: 30px;
                        font-weight: bold;
                    }

                    &::after {
                        content: ' ';
                        border: 1px solid #F1F1F1;
                        position: absolute;
                        bottom: 0;
                        left: 33px;
                        width: 613px;
                        height: 1px;
                    }

                    input {
                        text-align: right;
                        color: #999999;

                        &::-webkit-input-placeholder {
                            color: #D8D8D8;
                        }
                    }

                    .idot {
                        color: #FF3939;
                        margin-right: 10px;
                    }

                }
            }
        }

        .form-item-btn {
            margin: 50px 0;
        }
    }

</style>
